export const footer = {
  "description": "La plateforme d'échange de logements entre propriétaires Airbnb. Voyagez gratuitement partout dans le monde.",
  "company": "Entreprise",
  "about": "À propos",
  "howItWorks": "Comment ça marche",
  "blog": "Blog",
  "careers": "Carrières",
  "support": "Assistance",
  "help": "Centre d'aide",
  "contact": "Contact",
  "terms": "Conditions d'utilisation",
  "privacy": "Confidentialité",
  "community": "Communauté",
  "members": "Membres",
  "destinations": "Destinations",
  "events": "Événements",
  "newsletter": "Lettre d'information",
  "newsletterText": "Recevez nos dernières offres et actualités",
  "emailPlaceholder": "Votre email",
  "newsletterSuccess": "Inscription réussie !",
  "newsletterError": "Une erreur est survenue.",
  "newsletterInvalid": "Email invalide.",
  "subscribe": "S'abonner",
  "rights": "Tous droits réservés",
  "madeWith": "Fait avec",
  "by": "par l'équipe DONKEY TRAVEL"
};
